import { useContext } from "react";
import { MainContext } from "../../contexts/main";
import { useActiveLicense } from "../../hooks/useActiveLicense";
import { timestampToLongDate } from '@educaplay/app-core/time';
import { getText } from '@educaplay/app-core/language';

const licensesText = (license) => {
  return `${license.licenses} ${getText("licencias")}`;
};

const untilText = (license) => {
  if (
    !license ||
    license.expiration === undefined ||
    license.expiration === null
  )
    return "";
  return ` ${getText("until")} ${timestampToLongDate(license.expiration)}`;
};

const fromText = (timestamp) => {
  if (timestamp === undefined || timestamp === null) return "";
  return ` ${getText("from")} ${timestampToLongDate(timestamp)}`;
};

export const BlockInfoPlan = ({ id }) => {
  const { mainReducer } = useContext(MainContext);
  const subLicense = mainReducer.state.subLicense;
  const { activeLicense, samePlan, currentLicense, inProgressLicense } = useActiveLicense();
  
  const hasFuturePlan = !samePlan;
  const isAssignedCard =
    subLicense !== false && Number(subLicense) === Number(id);
  const isCurrentCard = Number(activeLicense.id) === Number(id);
  const isFutureCard =
    hasFuturePlan && Number(currentLicense.id) === Number(id);
  const statusMessages = [];

  if (isAssignedCard) {
    statusMessages.push({
      type: "assigned",
      text: `${(getText("plan_asignado"))}`,
    });
  }

  if (isCurrentCard) {
    const innerParts = [];

    if (activeLicense.licenses > 1) {
      innerParts.push(licensesText(activeLicense));
    }

    if (activeLicense.expiration) {
      innerParts.push(untilText(activeLicense));
    }

    const innerText = innerParts.join(" ");
    statusMessages.push({
      type: "current",
      text:
        innerText.length > 0
          ? `${getText("plan_actual")} (${innerText})`
          : `${getText("plan_actual")}`,
    });
  }

  if (isFutureCard) {
    const innerParts = [];
    if (currentLicense.licenses > 1) {
      innerParts.push(licensesText(currentLicense));
    }
    if (inProgressLicense.expiration) {
      innerParts.push(fromText(inProgressLicense.expiration));
    }
    const innerText = innerParts.join(" ");
    statusMessages.push({
      type: "future",
      text:
        innerText.length > 0
          ? `${getText("next_plan")} (${innerText})`
          : `${getText("next_plan")}`,
    });
  }

  return (
    <>
      {statusMessages.length > 0 &&
        mainReducer.state.user !== false &&
        statusMessages.map((msg, index) => (
          <div key={index} className={`e__plns__lst__plan__msg`}>
            {msg.text}
          </div>
        ))}
    </>
  );
};
